const additionalDefaultSvgAttributes = {
  height: '1em',
  width: '1em',
};

export default additionalDefaultSvgAttributes;
